export const MultiSelectStyle = {
  multiValue: (baseStyles, state) => {
      return {
        ...baseStyles,
        borderRadius: "12px",
        flexDirection: "row-reverse",
        padding: "0px 4px 0px",
        backgroundColor: "#DBF1FD",
        alignItems: "center"
      }
  },
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    ':hover': {
      borderRadius: "20px",
      padding: "0px",
      height: "16px",
      width: "16px",
      backgroundColor: "#1EA8E1",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: "2px",
      marginRight: "4px"
    }
  })
}
